import { isMobileSafari } from './device-detection';

let allowScrollElement;
let allowScrollElementChildren;

const lockBodyScroll = (element) => {
    if (!isMobileSafari) {
        document.body.classList.add('no-scroll');
        return;
    }

    if (!element) {
        window.addEventListener('touchmove', (e) => e.preventDefault());
        return;
    }

    allowScrollElement = element;
    allowScrollElementChildren = [...allowScrollElement.querySelectorAll('*')];

    window.addEventListener('touchmove', handleTouchMove, { passive: false });
    window.addEventListener('scroll', handleTouchMove, { passive: false });
}

const unlockBodyScroll = (element) => {
    if (!isMobileSafari) {
        document.body.classList.remove('no-scroll');
        return;
    }

    if (!element) {
        window.removeEventListener('touchmove', (e) => e.preventDefault());
        return;
    }

    window.removeEventListener('touchmove', handleTouchMove, { passive: false });
    window.removeEventListener('scroll', handleTouchMove, { passive: false });
}

const handleTouchMove = (e) => {
    const isTargetElement = e.target === allowScrollElement;
    const isTargetElementChild = allowScrollElementChildren.includes(e.target);

    if (!isTargetElement || !isTargetElementChild) e.preventDefault();
}

export {
    lockBodyScroll,
    unlockBodyScroll,
}
